export interface TipoPrestadorModel {
  valor?: string;
  nome?: string;
}

export const tiposPrestadorList: TipoPrestadorModel[] = [
  { valor: "CLINICA", nome: "Clínica" },
  { valor: "CONSULTORIO", nome: "Consultório" },
  { valor: "HOSPITAL", nome: "Hospital" },
  { valor: "LABORATORIO", nome: "Laboratório" },
];

